// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

const c_npcTalk = [
    '小子，这还能被你找到，这里可是贵妃居所，你跟那个贵妃关系不浅呀',
    '什么最危险的地方就是最安全的地方，还不是被找到了',
    '你想救你老婆，你打倒我们这些兄弟再说',
    '别打了别打了，你老婆被关在河边木屋里啦',
]

@ccclass
export default class HitRobLayer extends BasePopUpLayer {

    @property(cc.Node)
    sprNpcTalk: cc.Node = null;
    @property(cc.Node)
    nodeStep1: cc.Node = null;
    @property(cc.Node)
    nodeStep2: cc.Node = null;
    @property(cc.Node)
    nodeStep3: cc.Node = null;
    @property(cc.Label)
    labelNpcTalk: cc.Label = null;

    private curStep = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.resetStart();
    }

    resetStart() {
        this.curStep = 0;
        this.nodeStep1.active = false;
        this.nodeStep2.active = false;
        this.nodeStep3.active = false;
        this.sprNpcTalk.active = false;
    }

    startStep1() {
        this.curStep = 1;
        this.showNpcChat(c_npcTalk[0]);
        this.scheduleOnce(this.startStep2, 3);
    }

    startStep2() {
        this.curStep = 2;
        this.showNpcChat(c_npcTalk[1]);
        this.scheduleOnce(this.startStep3, 1);
    }

    startStep3() {
        this.curStep = 3;
        this.nodeStep1.active = true;
        this.nodeStep1.opacity = 0;
        cc.tween(this.nodeStep1)
        .to(0.25, {opacity: 255})
        .start();
    }

    startStep4() {
        
        this.curStep = 4;
        this.showNpcChat(c_npcTalk[2]);
        this.scheduleOnce(this.startStep5, 1);
    }

    startStep5() {
        this.curStep = 5;
        this.nodeStep2.active = true;
        this.nodeStep2.opacity = 0;
        cc.tween(this.nodeStep2)
        .to(0.25, {opacity: 255})
        .start();
    }

    startStep6() {
        this.curStep = 6;
        this.showNpcChat(c_npcTalk[3]);
        this.scheduleOnce(this.startStep7, 1);
    }

    startStep7() {
        this.curStep = 7;
        this.nodeStep3.active = true;
        this.nodeStep3.opacity = 0;
        cc.tween(this.nodeStep3)
        .to(0.25, {opacity: 255})
        .start();
    }

    showNpcChat(chat:string){
        this.sprNpcTalk.active = true;
        this.sprNpcTalk.scale = 0;
        this.labelNpcTalk.string = chat;
        cc.tween(this.sprNpcTalk).to(0.2,{scale:1}).start();
    }

    onClickEextStep() {
        if (this.curStep == 0) {
            this.startStep1();
        } else if(this.curStep == 1) {
            this.unschedule(this.startStep2);
            this.startStep2();
        } else if(this.curStep == 2) {
            this.unschedule(this.startStep3);
            this.startStep3();
        } else if(this.curStep == 4) {
            this.unschedule(this.startStep5);
            this.startStep5();
        } else if(this.curStep == 6) {
            this.unschedule(this.startStep7);
            this.startStep7();
        }  
    }

    onClickStep1() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.nodeStep1.active = false;
        this.startStep4();
    }

    onClickStep2_1() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.nodeStep2.active = false;
        utilsView.openPopupLayer(
            'prefab/HitRobGameLayer'
            , BUNDLE_SMALL_NAME.hitRobBundle
            , null
            , {
                parent: this
            }
        );
    }

    onClickStep2_2() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeLayer();
    }

    onClickStep3() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeLayer();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeLayer();
    }

    closeLayer() {
        this.node.destroy();
        this._carryData.parent.destroyNode();
    }

    // update (dt) {}
}
